export default "__VITE_ASSET__DFtQE6My__"